import React from "react";

import { BlockTitle } from "../../Component";
import VacancyFieldBlock from "./VacancyFieldBlock";

const FIELDS = [
  { field: "jobDescription", label: "Job description" },
  { field: "subDescription", label: "Sub description" },
  { field: "reportsTo", label: "Reports to" },
  { field: "term", label: "Term" },
  { field: "deadline", label: "Deadline" },
];

const VacancyDetailsBlock = () => (
  <div className="mt-4">
    <BlockTitle tag="h5" className="mb-3">
      Details
    </BlockTitle>

    {FIELDS.map(({ field, label }) => (
      <VacancyFieldBlock
        key={field}
        label={label}
        getInitial={(normalized) => normalized[field]}
        getSaved={(vacancy) => vacancy?.[field]}
        buildPatch={(value) => ({ [field]: value })}
      />
    ))}
  </div>
);

export default VacancyDetailsBlock;
